var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "management-add-button-container",
      attrs: { row: "", "justify-end": "" }
    },
    [
      _c(
        "v-flex",
        { attrs: { shrink: "" } },
        [
          _c(
            "missing-permissions-tooltip",
            {
              attrs: { "missing-permissions-list": _vm.listMissingPermissions }
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ma-0 management-button",
                  attrs: { color: "accent", disabled: _vm.disabled },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.click.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [_vm._v("add_circle")]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        "text-transform": "none"
                      }
                    },
                    [_vm._v("\n          " + _vm._s(_vm.label) + "\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21d6eb18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21d6eb18","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Management/ManagementAddButton.vue
// module id = null
// module chunks = 